var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{class:_vm.$style.container},_vm._l((_vm.crumbs),function(crumb,index){return _c('li',{key:index},[_c('a',{attrs:{"href":crumb.url,"target":"_top"},domProps:{"innerHTML":_vm._s(crumb.title)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }